import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../config";
import "../Styles/reset.css";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setMessage("Password must be at least 6 characters");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${API_BASE_URL}/api/auth/reset-password`,
        {
          token,
          password,
        }
      );

      setMessage(res.data.message || "Password reset successful");

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Password reset failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-login-container">
      {/* LEFT SIDE */}
      <div className="reset-login-left">
        <img
          src="/OS_logo_db.png"
          alt="Logo"
          className="reset-login-logo-img"
        />

        <div className="reset-login-illustration">
          <img src="/Admin_login_img.png" alt="Reset Password" />
        </div>

        <div className="reset-login-left-bottom">
          <h2>Reset Password</h2>
          <p>Create a new password for your admin account</p>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="reset-login-right">
        <div className="reset-login-form">
          <h2 className="reset-form-heading">Reset Password</h2>
          <p className="reset-form-subheading">
            Enter your new password below
          </p>

          <form onSubmit={handleSubmit}>
            <label className="reset-form-label">New Password</label>
            <div className="reset-password-field">
              <input
                className="reset-form-input"
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <img
                src="/Admin_log_eye.png"
                alt="Toggle password visibility"
                className="reset-password-eye-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>

            <label className="reset-form-label">Confirm Password</label>
            <div className="reset-password-field">
              <input
                className="reset-form-input"
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="reset-primary-btn"
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>

          {message && (
            <p
              style={{
                marginTop: "16px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
                fontWeight: 500,
                color: message.toLowerCase().includes("success")
                  ? "green"
                  : "red",
              }}
            >
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}